import { render, staticRenderFns } from "./ConfigForm.vue?vue&type=template&id=6dd0fa65&"
import script from "./ConfigForm.vue?vue&type=script&lang=js&"
export * from "./ConfigForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dd0fa65')) {
      api.createRecord('6dd0fa65', component.options)
    } else {
      api.reload('6dd0fa65', component.options)
    }
    module.hot.accept("./ConfigForm.vue?vue&type=template&id=6dd0fa65&", function () {
      api.rerender('6dd0fa65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/portal-cebas/credentialing/ConfigForm.vue"
export default component.exports